import React from "react";
import NavigateBackButton from "reusables/NavigateBackButton";

const NotFound = () => {
  return (
    <>
      <NavigateBackButton />
      <h1>404 Page not found</h1>
    </>
  )
};

export default NotFound;